import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	List,
	ListItem,
	ListItemText,
	Typography,
} from '@mui/material';
import { actionTwoButtonStyle } from 'src/theme';

/**
 * Dialog shown when a user tries to delete an item that is still in use.
 * Displays a message plus the list of entities that reference the item.
 *
 * @param {boolean} open - whether the dialog is open
 * @param {string} title - dialog title
 * @param {string} message - explanation of why the item cannot be deleted
 * @param {Array<{ name: string, type?: string, status?: string }>} usedBy -
 *        the entities blocking the delete
 * @param {() => void} onClose - close handler
 */
export function InUseDialog({
	open,
	title = 'Item In Use',
	message,
	usedBy = [],
	onClose,
}) {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>
				<Typography variant="h5" sx={{ textAlign: 'center' }}>
					<>{title}</>
				</Typography>
			</DialogTitle>
			<DialogContent>
				<Typography variant="subtitle1" sx={{ mb: usedBy.length ? 2 : 0 }}>
					<>{message}</>
				</Typography>
				{usedBy.length > 0 && (
					<Box>
						<Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
							Used by:
						</Typography>
						<List dense disablePadding sx={{ listStyleType: 'disc', pl: 3 }}>
							{usedBy.map((item, index) => (
								<ListItem
									key={`${item.name}-${index}`}
									disablePadding
									sx={{ display: 'list-item' }}
								>
									<ListItemText
										primary={item.name}
										secondary={[item.type, item.status]
											.filter(Boolean)
											.join(' \u2022 ')}
									/>
								</ListItem>
							))}
						</List>
					</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button sx={actionTwoButtonStyle} onClick={onClose}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
}
